import * as X from "@/ui";

import type { Article } from "@/providers/strapi";


export function ArticleCover(props: Omit<React.ComponentProps<typeof X.Image>, "src" | "alt" | "width" | "height" | "article" | "format"> & {
  article: Article;
  size?: "large" | "medium" | "small" | "thumbnail";
  alt?: string;
}) {
  const cover = props.article.cover;
  const formats = cover.formats;
  const size = props.size;

  const image: Format = (
    (size && formats && formats[size] !== undefined)
      ? formats[size]
      : cover
  );

  type Format = {
    url: string;
    width: number;
    height: number;
    mime: string;
  };

  // Default sizes based on common responsive patterns
  const defaultSizes = props.fill
    ? "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
    : undefined;

  return (
    <X.Image
      {...props}
      src={image.url}
      width={props.fill ? undefined : image.width}
      height={props.fill ? undefined : image.height}
      alt={props.alt ?? `Article ${props.article.id}`}
      sizes={props.sizes ?? defaultSizes}
      unoptimized={true}
    />
  );
}
